import { Component, Inject, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { LoadingService } from '../../loading/loading.service';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, debounceTime, distinctUntilChanged, finalize, of, switchMap, take } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertComponent } from '../../alert/alert.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalComponent } from '../../modal/modal.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-vincular-concessionaria',
  templateUrl: './vincular-concessionaria.component.html',
  styleUrls: ['./vincular-concessionaria.component.scss']
})
export class VincularConcessionariaComponent implements OnInit {

  entities: any[] = [
  ];
  selectedEntitie: any;
  dataSource = new MatTableDataSource<any>([

  ]);
  filteredOptions: any[] = [];
  orderBy: string = '';
  cnpj: string = '';
  razaoSocial: string = '';
  entitiesList: any[] = [];
  sortState: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  pageSize: number = 10;
  pageIndex: number = 0;
  totalPages: number = 1;
  totalElements: number = 0;
  displayedColumns: string[] = ['cnpj', 'razaoSocial', 'acoes']
  entitieId!: string;
  cnpjOrRazaoSocial: any;
  nameEntitie: any;
  searchControl = new FormControl();
  selectedOption: any;
  buttonInclusaoDisabled:boolean = false;
  buttonExclusaoDisabled:boolean = false;
  disabledTooltipMessage: string = 'Ação não permitida';
  constructor(private snackBar: OpenSnackbarService,
    private entitieService: EntitiesService,
    private loadingService: LoadingService,
    private dialogRef: MatDialogRef<VincularConcessionariaComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.entitieId = this.data?.entitieId;
    this.nameEntitie = this.data?.nameEntitie;
    this.buttonInclusaoDisabled = this.data?.buttonInclusaoDisabled;
    this.buttonExclusaoDisabled = this.data?.buttonExclusaoDisabled;
    this.onGetEntitie()
    // this.onGetAvilableEntitie()

    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.entitieService.getEntities(0, '', '', 'Concessionária', '', '', 'true').pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptions = results.content
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (filterValue.length >= 3 || filterValue.length === 0) {

      this.cnpjOrRazaoSocial = filterValue
      this.onGetEntitie();
    }

  }
  onSortChange(sortProperty:  'razaoSocial' | 'cnpj' ): void {


    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {

      this.sortState.sortDirection = 'asc';
    }
    this.sortState.sortProperty = sortProperty;

    this.onGetEntitie();
  }

  onGetEntitie(pageIndex: number = 0, respLegal?: boolean) {
    this.entitieService.getEntitieConcessionVinculated(this.entitieId,
      this.sortState.sortDirection,
      this.sortState.sortProperty, this.cnpj, this.razaoSocial, this.cnpjOrRazaoSocial).pipe(take(1), finalize(() => {
        this.loadingService.hideLoading()
      })).subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } =
            res;
          this.dataSource.data = content;
          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;
        },
        error: (err: any) => {
          this.openSnackBar(err.error.message, 'error')
        }
      })
  }

  // onGetAvilableEntitie() {

  //   this.entitieService.getConcessionDisponivel(this.entitieId).pipe(take(1), finalize(() => {
  //     this.loadingService.hideLoading()
  //   })).subscribe({
  //     next: (res: any) => {
  //       this.entities = res.content
  //     },
  //     error: (err: any) => {
  //       this.openSnackBar(err.error.message, 'error')
  //     }
  //   })

  // }

  pageChangeEvent(event: PageEvent) {
    if (this.pageIndex !== event.pageIndex) {
      this.onGetEntitie(event.pageIndex)
    }
  }

  removeEntitie(entitie_id: number) {
    const data = {
      "unidadeAdministrrativa": entitie_id
    }

    this.entitieService.removeVinculoConcession(this.entitieId, data).pipe(take(1), finalize(() => {
      this.loadingService.hideLoading()
    })).subscribe({
      next: (res: any) => {
        this.onGetEntitie()
        this.openSnackBar('Unidade administrativa Removida com sucesso!', 'sucess')
      },
      error: (err: any) => {
        this.openSnackBar(err.error.message, 'error')
      }
    })
  }

  back() {
    this.dialogRef.close()
  }

  updatedConcessions() {
    const data: any[] = [
      {
        "concessoes": [
          this.selectedEntitie
        ]
      }
    ];
    this.entitieService.vinculateEntiteConcession(this.entitieId, data).pipe(take(1), finalize(() => {
      this.loadingService.hideLoading()
    })).subscribe({
      next: (res: any) => {
        this.openSnackBar(res.message, 'sucess')
        this.onGetEntitie();
        this.searchControl.setValue('');
      },
      error: (err: any) => {

        this.openSnackBar(err.error.message, 'error')
      }
    })
  }

  openDeleteDialog(id: string): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja remover esse vinculo?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.removeEntitie.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  onOptionSelected(event: any) {
    this.selectedOption = event.option.value;
    this.searchControl.setValue(this.selectedOption.razaoSocial, { emitEvent: false });
    // this.form.get('idEntidade')?.setValue(this.selectedOption.id)
    this.filteredOptions = [];
    this.selectedEntitie = this.selectedOption

  }

}
